import Provider, { createProvider } from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, createProvider, connectAdvanced, connect };


// WEBPACK FOOTER //
// /~/react-redux/es/index.js